import React from "react";
import { BaseBadge } from "./styled";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
function Badge(_ref) {
  var variant = _ref.variant,
    _ref$color = _ref.color,
    color = _ref$color === void 0 ? "accent" : _ref$color,
    content = _ref.content,
    _ref$position = _ref.position,
    position = _ref$position === void 0 ? "topRight" : _ref$position,
    children = _ref.children;
  var isInline = !children || !children && !variant;
  var renderBadge = function renderBadge() {
    return /*#__PURE__*/_jsx(BaseBadge, {
      "aria-label": "Badge showing ".concat(content, " count"),
      inline: isInline,
      variant: variant,
      color: color,
      position: isInline ? null : position,
      children: variant === "dot" ? null : content
    });
  };
  if (!children) {
    return renderBadge();
  }
  return /*#__PURE__*/_jsxs("div", {
    style: {
      position: "relative"
    },
    children: [children, renderBadge()]
  });
}
export default Badge;